import { render, staticRenderFns } from "./WhistleBlowing.vue?vue&type=template&id=734c6746&"
import script from "./WhistleBlowing.vue?vue&type=script&lang=js&"
export * from "./WhistleBlowing.vue?vue&type=script&lang=js&"
import style0 from "./WhistleBlowing.vue?vue&type=style&index=0&id=734c6746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports